"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatedColumnInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class CalculatedColumnInternalApi extends ApiBase_1.ApiBase {
    /**
     * Returns all the references in the AdaptableState of the given CalculatedColumn
     * @param calculatedColumn CalculatedColumn to be checked
     */
    getCalculatedColumnModuleReferences(calculatedColumn) {
        const references = [];
        this.adaptable.adaptableModules.forEach((module) => {
            if (module
                .getModuleCalculatedColumnReferences()
                .some((moduleReference) => moduleReference.Uuid === calculatedColumn.Uuid)) {
                references.push(module.moduleInfo.FriendlyName);
            }
        });
        return references;
    }
    /**
     * Returns all Calculated Columns whose Expression contains the ColumnId
     * @param columnId ColumnId to check
     */
    getCalculatedColumnsReferencingColumnId(columnId) {
        const calcColumns = [];
        this.getCalculatedColumnApi()
            .getCalculatedColumns()
            .forEach((calculatedColumn) => {
            if (this.getExpressionApi().internalApi.isColumnReferencedInExpression(columnId, this.adaptable.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query))) {
                calcColumns.push(calculatedColumn);
            }
        });
        return calcColumns;
    }
    /**
     * Gets any ColumnIds referenced in a Calculated Column
     * @param calculatedColumn Calculated Column to check
     */
    getReferencedColumnIdsForCalculatedColumn(calculatedColumn) {
        const columnIds = this.adaptable.api.expressionApi.getColumnsFromExpression(this.adaptable.api.expressionApi.getAdaptableQueryExpression(calculatedColumn.Query));
        return columnIds;
    }
    /**
     * Gets any ColumnIds referenced in a Calculated Column
     * @param calculatedColumnId CalculatedColumnId to check
     */
    getReferencedColumnIdsForCalculatedColumnId(calculatedColumnId) {
        const calculatedColumn = this.adaptable.api.calculatedColumnApi
            .getCalculatedColumns()
            .find((cc) => cc.ColumnId == calculatedColumnId);
        if (calculatedColumn) {
            return this.getReferencedColumnIdsForCalculatedColumn(calculatedColumn);
        }
    }
    getCalculatedColumnsDependentOnColumn(column) {
        const calculatedColumns = this.adaptable.api.calculatedColumnApi.getCalculatedColumns();
        return calculatedColumns
            .filter((calculatedColumn) => {
            const dependentColumns = this.getReferencedColumnIdsForCalculatedColumnId(calculatedColumn.ColumnId);
            return dependentColumns.includes(column.columnId);
        })
            .map((calculatedColumn) => calculatedColumn.ColumnId);
    }
    isCumulativeAggregatedExpression(input) {
        var _a;
        return !!((_a = this.getAdaptableApi()
            .internalApi.getQueryLanguageService()
            .getNodesFromExpression(input, 'CUMUL')) === null || _a === void 0 ? void 0 : _a.length);
    }
    isQuantileAggregatedExpression(input) {
        var _a;
        return !!((_a = this.getAdaptableApi()
            .internalApi.getQueryLanguageService()
            .getNodesFromExpression(input, 'QUANT')) === null || _a === void 0 ? void 0 : _a.length);
    }
}
exports.CalculatedColumnInternalApi = CalculatedColumnInternalApi;
